import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    height = "height",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.height]: number;
    };
}

type Props = OwnProps;

const ContentSpacer: React.FunctionComponent<Props> = ({ fields }: Props) => {
    const styles = {
        css: css`
            height: ${fields.height}px;
            background: transparent;
            width: 100%;
        `,
    };
    return <StyledWrapper {...styles}></StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: ContentSpacer,
    definition: {
        group: "Basic",
        icon: "Banner",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.height,
                displayName: "Height",
                editorTemplate: "IntegerField",
                defaultValue: 15,
            },
        ],
    },
};

export default widgetModule;
